import translations from './data.js.erb'

export function t(key, locale) {
    return translations()[locale || 'en'][key];
}
